import React from "react";
import { Box, Typography, Stack, Divider } from "@mui/material";
import { CheckCircle, Warning, Error as ErrorIcon } from "@mui/icons-material";

/**
 * SeoChecklist Component
 * Renders grouped actionable recommendations.
 */
const SeoChecklist = ({ breakdown }) => {
  if (!breakdown) return null;

  const renderItem = (item, index) => {
    let Icon = CheckCircle;
    let color = "#10b981"; // success
    let iconColor = "#10b981";

    if (item.status === "warning") {
      Icon = Warning;
      color = "#475569";
      iconColor = "#fbbf24";
    } else if (item.status === "error") {
      Icon = ErrorIcon;
      color = "#475569";
      iconColor = "#ef4444";
    }

    return (
      <Stack
        key={index}
        direction="row"
        spacing={1.5}
        alignItems="flex-start"
        sx={{ mb: 1.5 }}
      >
        <Icon sx={{ color: iconColor, fontSize: 20, mt: 0.3 }} />
        <Typography variant="body2" sx={{ color, lineHeight: 1.5 }}>
          {item.text}
        </Typography>
      </Stack>
    );
  };

  const Section = ({ title, items }) => {
    if (!items || items.length === 0) return null;
    return (
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            color: "#1E293B",
            mb: 1.5,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            fontSize: "0.75rem",
          }}
        >
          {title}
        </Typography>
        {items.map(renderItem)}
      </Box>
    );
  };

  return (
    <Box sx={{ px: 1 }}>
      <Section title="Focus Keyword" items={breakdown.keyword} />
      <Divider sx={{ my: 2 }} />
      <Section title="Title Optimization" items={breakdown.title} />
      <Divider sx={{ my: 2 }} />
      <Section title="Meta Description" items={breakdown.meta} />
      <Divider sx={{ my: 2 }} />
      <Section title="Content Quality" items={breakdown.content} />
      <Divider sx={{ my: 2 }} />
      <Section title="Readability" items={breakdown.readability} />
      <Divider sx={{ my: 2 }} />
      <Section title="Technical SEO" items={breakdown.technical} />
    </Box>
  );
};

export default SeoChecklist;
